import { render, staticRenderFns } from "./inventoryReportsIndex.vue?vue&type=template&id=486cc380&"
import script from "./inventoryReportsIndex.vue?vue&type=script&lang=js&"
export * from "./inventoryReportsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports